module.exports = __webpack_public_path__ + "assets/eecf8b033f11e42312fa84543fedc67f.png";